(() => {
  if (window.normPrivacyControls) return;
  window.normPrivacyControls = true;

  const waitFor = (test, deadline) => new Promise((resolve, reject) => {
    const poll = () => {
      if (test()) { resolve(); return; }
      if (Date.now() >= deadline) { reject(new Error('Privacy preferences unavailable')); return; }
      window.setTimeout(poll, 100);
    };
    poll();
  });
  const modalVisible = () => {
    const modal = document.getElementById('shopify-pc__prefs__dialog');
    return Boolean(modal && modal.getClientRects().length && getComputedStyle(modal).visibility !== 'hidden');
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-privacy-open]');
    if (!button || button.disabled) return;
    const status = button.closest('[data-privacy-controls]').querySelector('[data-privacy-status]');
    const label = button.textContent;
    const deadline = Date.now() + 10000;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = button.dataset.loadingLabel;
    status.textContent = '';
    try {
      await waitFor(() => document.readyState !== 'loading' && typeof window.privacyBanner?.showPreferences === 'function', deadline);
      // An existing banner, even hidden after consent, proves native boot has rendered.
      // Where Shopify does not render a banner, allow its initial async boot to settle.
      await waitFor(() => Boolean(document.getElementById('shopify-pc__banner')), Math.min(deadline, Date.now() + 1000)).catch(() => {});
      for (let attempt = 0; attempt < 2; attempt++) {
        // Shopify's promise resolves before its async modal render; verify the actual UI.
        // This documented display API does not accept or save any consent choice.
        Promise.resolve(window.privacyBanner.showPreferences()).catch(() => {});
        await waitFor(modalVisible, Math.min(deadline, Date.now() + 4000)).catch(() => {});
        if (modalVisible()) return;
        if (Date.now() >= deadline) break;
      }
      throw new Error('Privacy preferences unavailable');
    } catch {
      status.textContent = button.dataset.errorLabel;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = label;
    }
  });
})();
